/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_App_MainstreamInputs */

const en_why_listening_app_mainstream = /** @type {(inputs: Why_Listening_App_MainstreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mainstream reader`)
};

const es_why_listening_app_mainstream = /** @type {(inputs: Why_Listening_App_MainstreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lector generalista`)
};

/**
* | output |
* | --- |
* | "Mainstream reader" |
*
* @param {Why_Listening_App_MainstreamInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_app_mainstream = /** @type {((inputs?: Why_Listening_App_MainstreamInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_App_MainstreamInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_app_mainstream(inputs)
	return en_why_listening_app_mainstream(inputs)
});